import { useEffect, useContext, useCallback } from 'react';

import type { Auth } from '@shared/types';

import useAxios from '@services/api';

import { authContext } from '@store/index';

export const useFetchClient = () => {
  const [authData, setAuthData] = useContext(authContext);
  const { response, error, issueRequest, loading, statusCode } =
    useAxios<Auth>();

  const fetchClient = useCallback((force = false) => {
    // Не делаем запрос на странице логина, если не указан force
    if (!force && window.location.pathname.includes('/login')) {
      console.log('Skipping fetchClient on login page');
      return;
    }
    // Проверяем флаг принудительного выхода
    if (localStorage.getItem('forceLogout') === 'true') {
      console.log('Skipping fetchClient due to forceLogout flag');
      return;
    }
    console.log('🔍 Fetching client data...', { force, pathname: window.location.pathname });
    issueRequest({ 
      url: `/auth/user?t=${Date.now()}`, 
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    }).catch(err => {
      // Игнорируем ошибку, так как она обрабатывается в useAxios и useEffect
      console.log('🔍 Fetching client data: User not found or session expired (expected for guests)');
    });
  }, [issueRequest]);

  useEffect(() => {
    if (response) {
      setAuthData(response);
    }

    if (statusCode === 401) {
      setAuthData(undefined);
    }
  }, [response, statusCode, setAuthData]);

  return [response, fetchClient, loading] as const;
};

